import { AIModelKind } from '../smartbotAI';

import {
  AIModelPricing,
  AIModelPricingRowKind,
  AIModelPricingTier,
  AITariffication
} from './client';
import { AIModelPricingServer, AITarifficationServer } from './server';

const toTier = (base: number, second?: number): AIModelPricingTier => {
  const tier: AIModelPricingTier = { base };

  if (second !== undefined && second !== base) {
    tier.second = second;
  }

  return tier;
};

export const normalizeAIModelPricing = (
  raw: AIModelPricingServer
): AIModelPricing => ({
  [AIModelPricingRowKind.input]: toTier(raw.input_cost, raw.input_cost_long),
  [AIModelPricingRowKind.cached]: toTier(raw.cached_cost, raw.cached_cost_long),
  [AIModelPricingRowKind.output]: toTier(raw.output_cost, raw.output_cost_long)
});

export const normalizeAITariffication = (
  raw: AITarifficationServer
): AITariffication =>
  Object.entries(raw).reduce<AITariffication>((acc, [modelKind, pricing]) => {
    if (pricing) {
      acc[modelKind as AIModelKind] = normalizeAIModelPricing(pricing);
    }

    return acc;
  }, {});
